var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96438 0.645C2.81077 0.798607 2.71668 1.01207 2.71698 1.24649V1.34967C2.71698 1.81913 3.09702 2.19917 3.56587 2.19857H8.20429L0.357902 10.045C0.0265243 10.3763 0.0265243 10.9142 0.357902 11.2456C0.689279 11.577 1.22717 11.577 1.55854 11.2456L9.40493 3.39921V8.03763C9.40493 8.50708 9.78497 8.88712 10.2538 8.88652H10.357C10.8265 8.88652 11.2065 8.50648 11.2059 8.03763V1.24649C11.2059 0.777042 10.8259 0.397001 10.357 0.397602H3.56587C3.33114 0.397602 3.11798 0.491392 2.96438 0.645Z",
    fill: "#85D87E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.9c49ec90c83ef3f35e3bdaeba8d9ba8e.svg";
export { ForwardRef as ReactComponent };